import React, { Component } from "react";
import "antd/dist/antd.css";
import {
  Table,
  Input,
  Button,
  Space,
  PageHeader,
  Breadcrumb,
  Tag,
  DatePicker,
  Select,
  Row,
  Col,
  Tooltip,
} from "antd";
import Highlighter from "react-highlight-words";
import {
  EyeOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { Content } from "antd/lib/layout/layout";
import { getBatch } from "../../actions/code";
import { Link } from "react-router-dom";
import history from "../../history";
import { connect } from "react-redux";
import { Pagination } from "antd";
const { RangePicker } = DatePicker;
const { Option } = Select;
class CodeMList extends Component {
  state = {
    searchText: "",
    searchedColumn: "",
    data: [],
    serviceDetails: null,
    detail: false,
    visible: false,
    passVisible: false,
    modalVisible: false,
    editModalVisible: false,
    placement: "bottom",
    id: "",

    a: null,
    e: null,
    ds: null,
    de: null,
    b: null,
    p: 1,
    current: 1,
  };
  componentDidMount = async () => {
    const res = await this.props.getBatch(
      this.state.p,
      this.state.e,
      this.state.a,
      this.state.b,
      this.state.ds,
      this.state.de
    );
    this.setState({ data: res });
  };
  
  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex,
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };
  createData = (
    sl,
    batch_id,
    batch_no,
    email,
    user_id,
    code_count,
    created_at,
    status,
    title,

    action
  ) => {
    return {
      sl,
      batch_id,
      batch_no,
      email,
      user_id,
      code_count,
      created_at,
      status,
      title,

      action,
    };
  };

  showDrawer = (id) => {
    this.setState({
      visible: true,
      id: id,
    });
  };
  handleRefresh = async () => {
    const res = await this.props.getBatch();
    this.setState({ data: res });
  };

  handlePassVisible = (id) => {
    this.setState({ passVisible: true, id: id });
  };
  handleModalVisible = () => {
    this.setState({ modalVisible: !this.state.modalVisible });
  };
  handleVisible = async (batch_id) => {
    
    history.push(`/batch-details?batch=${batch_id}`);
  };
  handleEditModalVisible = (user_id) => {
    this.setState({
      editModalVisible: !this.state.editModalVisible,
      id: user_id,
    });
  };
  onClosePass = () => {
    this.setState({
      passVisible: false,
    });
  };
  onClose = () => {
    this.setState({
      visible: false,
    });
  };
  makeLocalTime = (date) => {
    let mainDate = date.split("T")[0];
    let hours = date.split("T")[1].split(":")[0];
    let minutes = date.split("T")[1].split(":")[1];
    var am = true;
    if (hours > 12) {
      am = false;
      hours -= 12;
    } else if (hours == 12) {
      am = false;
    } else if (hours == 0) {
      hours = 12;
    }
    return (
      mainDate + " , " + hours + ":" + minutes + " " + (am ? "a.m" : "p.m")
    );
  };
  handleDate = (date) => {
    if (date) {
      const ds = new Date(date[0]._d);
      const de = new Date(date[1]._d);
      this.setState({ ds: ds.toISOString(), de: de.toISOString() });
    } else {
      this.setState({ ds: null, de: null });
      return;
    }
  };
  handlePageChange = async (page) => {
    const res = await this.props.getBatch(
      page,
      this.state.e,
      this.state.a,
      this.state.b,
      this.state.ds,
      this.state.de
    );
    this.setState({ current: page, data: res });
  };
  handleApiSearch = async () => {
    const res = await this.props.getBatch(
      this.state.p,
      this.state.e,
      this.state.a,
      this.state.b,
      this.state.ds,
      this.state.de
    );
    this.setState({ data: res });
  };

  render() {
    const columns = [
      {
        title: "SL",
        dataIndex: "sl",
        key: "sl",
        width: "10%",
      },
      {
        title: "Title",
        dataIndex: "title",
        key: "title",
        width: "20%",
        ...this.getColumnSearchProps("title"),
      },
      // {
      //   title: "User ID",
      //   dataIndex: "user_id",
      //   key: "user_id",
      //   width: "15%",
      //   ...this.getColumnSearchProps("user_id"),
      // },
      {
        title: "Batch ID",
        dataIndex: "batch_id",
        key: "batch_id",
        width: "15%",
        ...this.getColumnSearchProps("batch_id"),
      },
      {
        title: "Batch No",
        dataIndex: "batch_no",
        key: "batch_no",
        width: "15%",
        ...this.getColumnSearchProps("batch_no"),
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
        width: "25%",
        ...this.getColumnSearchProps("email"),
      },

      {
        title: "Total Code",
        dataIndex: "code_count",
        key: "code_count",
        width: "15%",
        ...this.getColumnSearchProps("code_count"),
      },
      {
        title: "Register Date",
        dataIndex: "created_at",
        key: "created_at",
        width: "25%",
        ...this.getColumnSearchProps("created_at"),
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        width: "15%",
        ...this.getColumnSearchProps("status"),
      },

      {
        title: "Action",
        dataIndex: "action",
        key: "action",
        width: "25%",
      },
    ];
    const { data } = this.state;
    const rows = [
      data?.batch
        ? data?.batch.map((item, id) =>
            this.createData(
              id + 1,
              item.batch_id,
              item.batch_no,
              item.client?.email,
              item.client?.user_id,
              item.code_count,
              this.makeLocalTime(item?.created_at),
              <>
                {item?.active === "active" ? (
                  <Tag color="#06bb1e">&nbsp;Active&nbsp;</Tag>
                ) : (
                  <Tag color="#e65907">&nbsp;Inactive&nbsp;</Tag>
                )}
              </>,
              item.title,

              <Button
                size="small"
                type="primary"
                icon={<EyeOutlined />}
                onClick={() => this.handleVisible(item.batch_id)}
              >
                View
              </Button>
              
            )
          )
        : "",
    ];
    return (
      <Content>
        <Breadcrumb style={{ padding: "10px 0px" }}>
          <Breadcrumb.Item>
            <Link to="/dashboard">Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Batch List</Breadcrumb.Item>
        </Breadcrumb>
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Batch List"
          subTitle="Code Management"
          extra={
            <Tag color="#2db7f5" style={{ fontSize: "15px", padding: "4px" }}>
              {" "}
              {data?.count} Batch found
            </Tag>
          }
        ></PageHeader>
        <br />
        <Row>
          <Col xs={12} sm={12} md={8} lg={8} xl={8}>
            <Input
              placeholder="Client Email"
              style={{ width: "99%" }}
              allowClear
              onChange={(e) => this.setState({ e: e.target.value })}
            />
          </Col>
          <Col xs={12} sm={12} md={8} lg={8} xl={8}>
            <Input
              placeholder="Batch Id"
              style={{ width: "99%" }}
              allowClear
              onChange={(e) => this.setState({ b: e.target.value })}
            />
          </Col>
          <br />
          <br />
          <Col xs={12} sm={12} md={8} lg={8} xl={8}>
            <Select
              showSearch
              style={{ width: "99%" }}
              placeholder="Select a status"
              name="status"
              optionFilterProp="children"
              onChange={(e) => this.setState({ a: e })}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              <Option value="">None</Option>
              <Option value="active">Active</Option>
              <Option value="inactive">Inactive</Option>
            </Select>
          </Col>

          <Col xs={12} sm={12} md={8} lg={8} xl={8}>
            <RangePicker
              onChange={this.handleDate}
              format="YYYY/MM/DD"
              style={{ width: "80%" }}
            />
            &nbsp; &nbsp;
            <Tooltip title="search" onClick={this.handleApiSearch}>
              <Button type="primary" shape="circle" icon={<SearchOutlined />} />
            </Tooltip>
          </Col>
        </Row>
        <br />

        <Table
          columns={columns}
          dataSource={rows[0]}
          scroll={{ x: 1000 }}
          sticky
          pagination={false}
        />
        <Pagination
          current={this.state.current}
          total={data?.count}
          pageSize="20"
          onChange={this.handlePageChange}
          pageSizeOptions={[20]}
        />
      
      </Content>
    );
  }
}

export default connect(null, { getBatch })(CodeMList);
